/**
 * @format
 * @Categoryat
 */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';

const Province = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [CategoryRemoveId, setCategoryRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getProvinces();
  }, [search]);
  const getProvinces = async () => {
    setLoading(true);
    await useApi.get(
      `/general/province/${search}`,
      {},
      (res) => {
        eventContext.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeCategory = async (categoryId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/general/province/${categoryId}`,
      {},
      (res) => {
        success('استان مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getProvinces();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست استان ها
          </h1>
        </div>
        <Link
          to='/panel/province/create'
          className='d-flex flex-row btn btn-outline-info '
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>ایجاد استان</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.provinces?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>لیست شهر ها</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.provinces?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.name}</td>
                  <td>
                    <Link to={`/panel/city/${item.id}`} className='mx-2'>
                      شهرها
                    </Link>
                  </td>
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        to={`/panel/province/edit/${item.id}`}
                        className='mx-2'
                      >
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setCategoryRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد استان بر روی منوی ایجاد استان کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.provinces?.meta?.pagination?.total_pages}
          basePath={`/panel/province`}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف استان مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeCategory(CategoryRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Province;
